import queryString from 'query-string';
import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchAssignments({ dispatch }, filters) {
  const queryParams = queryString.stringify(filters);

  return http.get(`${MINERVA_API_URL}/assignments?${queryParams}`)
    .then((res) => {
      if (filters.page === 1) {
        return dispatch('setAssignmentsInStore', res.data);
      }

      return dispatch('addAssignmentsInStore', res.data);
    })
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching assignments:', err);
      return Promise.reject(err);
    });
}

export function fetchTeacherAssignmentStats({ dispatch }, filters) {
  const queryParams = queryString.stringify(filters);

  return http.get(`${MINERVA_API_URL}/assignment-stats?${queryParams}`)
    .then(res => (
      dispatch('setTeacherAssignmentStatsInStore', res.data)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching assignment stats:', err);
      return Promise.reject(err);
    });
}

export function fetchAssignmentDetails({ dispatch }, assignmentId) {
  return http.get(`${MINERVA_API_URL}/assignments/${assignmentId}`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching assignment details:', err);
      return Promise.reject(err);
    });
}

export function createNewAssignment({ dispatch }, newAssignment) {
  return http.post(`${MINERVA_API_URL}/assignments`, newAssignment)
    .then(res => (
      dispatch('addAssignmentInStore', res.data)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while creating new assignment:', err);
      return Promise.reject(err);
    });
}

export function updateAssignment({ dispatch }, { assignmentId, updateInfo }) {
  return http.patch(`${MINERVA_API_URL}/assignments/${assignmentId}`, updateInfo)
    .then(() => {
      console.info('assignment updated!');
    })
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating assignment:', err);
      return Promise.reject(err);
    });
}

export function removeAssignment({ dispatch }, assignmentId) {
  return http.delete(`${MINERVA_API_URL}/assignments/${assignmentId}`)
    .then(() => (
      dispatch('removeAssignmentInStore', assignmentId)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while deleting assignment:', err);
      return Promise.reject(err);
    });
}

export function gradeAssignment({ dispatch }, params) {
  return http.patch(`${MINERVA_API_URL}/assignments/${params.assignment_id}/submissions/grades`, params)
    .then(() => {
      console.info('assignment graded!');
    })
    .catch((err) => {
      // TODO: handle error
      console.error('err while grading assignment submission:', err);
      return Promise.reject(err);
    });
}

export function gradeQuizResult({ dispatch }, params) {
  return http.patch(`${MINERVA_API_URL}/assignments/${params.assignment_id}/quiz_results/grades`, params)
    .then(() => {
      console.info('quiz graded!');
    })
    .catch((err) => {
      // TODO: handle error
      console.error('err while grading quiz result:', err);
      return Promise.reject(err);
    });
}

export function updateAssignmentResults({ dispatch }, params) {
  return http.patch(`${MINERVA_API_URL}/assignments/${params.assignment_id}/student-results`, params)
    .then(() => {
      console.info('assignment results updated!');
    })
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating assignment results:', err);
      return Promise.reject(err);
    });
}

export function fetchAssignedCardPages({ dispatch }, assignmentId) {
  return http.get(`${MINERVA_API_URL}/assignments/${assignmentId}/pages`)
    .then(res => (
      dispatch('setAssignedCardPages', { assignmentId, pageList: res.data })
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching assignment card pages:', err);
      return Promise.reject(err);
    });
}

export function setTeacherAssignmentStatsInStore({ commit }, assignmentStats) {
  commit(types.SET_ASSIGNMENT_STATS, assignmentStats);

  return Promise.resolve(assignmentStats);
}

export function setAssignmentsInStore({ commit }, assignmentList) {
  commit(types.SET_ASSIGNMENTS, assignmentList);

  return Promise.resolve(assignmentList);
}

export function addAssignmentsInStore({ commit }, assignmentList) {
  commit(types.ADD_ASSIGNMENTS, assignmentList);

  return Promise.resolve(assignmentList);
}

export function addAssignmentInStore({ commit }, newAssignment) {
  commit(types.ADD_ASSIGNMENT, newAssignment);

  return Promise.resolve(newAssignment);
}

export function updateAssignmentInStore({ commit }, assignment) {
  commit(types.UPDATE_ASSIGNMENT, assignment);

  return Promise.resolve(assignment);
}

export function setAssignmentPropertyInStore({ commit }, setInfo) {
  commit(types.SET_PROPERTY, setInfo);

  return Promise.resolve();
}

export function removeAssignmentInStore({ commit }, assignmentId) {
  commit(types.REMOVE_ASSIGNMENT, assignmentId);

  return Promise.resolve();
}

export function setSelectedAssignmentId({ commit }, assignmentId) {
  commit(types.SET_SELECTED, assignmentId);

  return Promise.resolve();
}

export function setSelectedCardForNewAssignment({ commit }, card) {
  commit(types.SET_SELECTED_CARD_FOR_NEW_ASMT, card);

  return Promise.resolve();
}

export function setAssignedCardPages({ commit }, setInfo) {
  commit(types.SET_CARD_PAGES, setInfo);

  return Promise.resolve(setInfo.pageList);
}

export function syncAssignmentSubmissions({ dispatch }, assignmentId) {
  return http.post(`${MINERVA_API_URL}/assignments/${assignmentId}/sync_submissions`)
    .then(() => {
      console.info('sync assignment submissions!');
    })
    .catch((err) => {
      console.error('err while sync assignment submissions:', err);
      return Promise.reject(err);
    });
}



// WEBPACK FOOTER //
// ./src/app/assignments/store/actions.js